import { Category, BACKEND_API } from '@trwl/backend.api';
import { createEffect, createEvent, createStore } from 'effector';
import { persist } from 'effector-storage/local';

export const $categories = createStore<Category[]>([]);

export const fetchCategoriesFx = createEffect<void, Category[], Error>(
  async () => {
    return BACKEND_API.CategoryApi.getCategories().then(({ data }) => data);
  },
);

$categories.on(fetchCategoriesFx.doneData, (_, categories) => categories);

export const loadCategories = createEvent();
loadCategories.watch(fetchCategoriesFx);
persist({ store: $categories, key: 'categories' });
